/*  MUI  */
import { Typography } from '@mui/material';

/* Hooks */
import { useFetchTenantPartnerToken } from 'hooks/dataAccess/Tenant/Token/tenantPartnerToken';
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';
import IntegrationScriptFilename from './Constants/IntegrationScriptsFilename.json';

/* Helpers */
import { getScript } from './Helpers/utils';

const deploymentSteps = async ({ appVersion, partnerToken, t }) => {
    const filenamePath = IntegrationScriptFilename.connectwiseScript;

    const filename = filenamePath.slice(filenamePath.lastIndexOf('/') + 1);

    const scriptCopyValue = await getScript({
        filename: filenamePath,
        token: partnerToken
    });

    return [
        {
            component: (
                <Typography variant="h4">
                    {t('Integrations.setup_process')}
                </Typography>
            ),
            step: false
        },
        { component: t('Integrations.ConnectWise.step1'), step: true },
        {
            component: (
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.ConnectWise.step2')
                    }}
                />
            ),
            step: true
        },
        {
            component: (
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.ConnectWise.step3')
                    }}
                />
            ),
            step: true
        },
        {
            component: t('Integrations.set_the_name'),
            copyValue: t('Integrations.asm_version', {
                appVersion
            }),
            step: true
        },
        {
            component: t('Integrations.set_the_description'),
            copyValue: t('Integrations.ConnectWise.step5_copyValue', {
                date: new Date()
            }),
            step: true
        },
        {
            component: `${t('Integrations.set_the_category')}:`,
            step: true,
            stepValue: t('Common.scripts')
        },
        {
            component: (
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.ConnectWise.step7', {
                            filename
                        })
                    }}
                />
            ),
            copyValue: scriptCopyValue,
            download: filename,
            step: true
        },
        {
            component: (
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.ConnectWise.step8')
                    }}
                />
            ),
            step: true
        },
        {
            component: (
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.ConnectWise.step9')
                    }}
                />
            ),
            step: true
        }
    ];
};

export const ConnectWise = ({ onboarding = false }) => {
    const { t } = useTranslation();
    const { partnerToken } = useFetchTenantPartnerToken();
    const [deploymentStepsArray, setDeploymentStepsArray] = useState([]);
    const userTheme = useUserTheme();

    let appVersion = '1.26.0';
    if (process.env.REACT_APP_VERSION) {
        appVersion = process.env.REACT_APP_VERSION;
    }

    useEffect(() => {
        async function fetchDeploymentSteps() {
            const response = await deploymentSteps({
                appVersion,
                partnerToken,
                t
            });
            setDeploymentStepsArray(response);
        }
        fetchDeploymentSteps();
    }, [appVersion, partnerToken, t]);

    return (
        <IntegrationWrapper
            hasToken
            deploymentSteps={deploymentStepsArray}
            headerTitle={t('Integrations.ConnectWise.title')}
            img={`/images/${userTheme}/integrations/connectwise.png`}
            imgWidth="200px"
            onboarding={onboarding}
        />
    );
};
